export class RoutesConstants {
  static login: string = '/login';
  static home: string = '/home';
  static SearchPatient: string = '/patients/patients-list';
  static NewPatient: string = '/patient/register';
}
